import {
defineCustomElement,
MediaTooltipElement,
MediaTooltipTriggerElement,
MediaTooltipContentElement
} from "vidstack/elements";

defineCustomElement(MediaTooltipElement);
defineCustomElement(MediaTooltipTriggerElement);
defineCustomElement(MediaTooltipContentElement);